<template>
  <div class="app-jumbotron-banner__container">
    <slot />
  </div>
</template>

<script>
export default {
  name: 'AppJumbotronBanner'
}
</script>

<style scoped>
.app-jumbotron-banner__container {
  font-family: "Avenir-Heavy";
  font-size: 1.5rem;
  color: #ffffff;
  letter-spacing: 0;
  text-align: center;
  margin-bottom: 5rem;
  user-select: none;
  transition: margin 300ms ease;
}

@media screen and (max-width: 775px) {
  .app-jumbotron-banner__container {
    margin-bottom: 1rem;
  }
}
</style>
